import { getFlagDefaults } from './getFlagDefaults';
import { getOpxHostAppName } from 'mini-opx-config/lib/getOpxHostAppName';
import { isNative } from './utils/isNative';
import {
    ANDROID_OUTLOOK,
    ANDROID_TEAMS,
    IOS_OUTLOOK,
    IOS_TEAMS,
    OUTLOOK_DESKTOP,
    OUTLOOK_EXTENSION,
} from 'owa-config';
import type { MiniHostAppFeature } from './miniHostAppFlags';

export function isMiniHostAppFeatureEnabled(flagName: MiniHostAppFeature): boolean {
    const featureFlags = getFlagDefaults(flagName);

    if (featureFlags) {
        // Host app config
        const hostApp = getOpxHostAppName();
        if (hostApp && hostApp in featureFlags) {
            return featureFlags[hostApp];
        }

        // Native config
        if (isNative() && 'native' in featureFlags) {
            return featureFlags.native;
        }

        if (
            hostApp &&
            (hostApp === IOS_OUTLOOK ||
                hostApp === ANDROID_OUTLOOK ||
                hostApp === OUTLOOK_EXTENSION ||
                hostApp === ANDROID_TEAMS ||
                hostApp === IOS_TEAMS ||
                hostApp === OUTLOOK_DESKTOP) &&
            'opx' in featureFlags
        ) {
            return featureFlags.opx;
        }
        return featureFlags.default;
    }

    return false;
}
